import styled from '@emotion/styled'

export const StyledCars = styled.div`


    display: flex;
    flex-direction: column;
    gap: 40px;

`